<div class="d-flex align-items-center justify-content-center overflow-100">
  <img src="./assets/img/contact-default.jpg" width="800" height="800" class="img-fluid" alt="" />
</div>
